module.exports = __webpack_public_path__ + "media/fonts/immaterial-c8826e264775d8a5e28480eb500272dd.woff2";